<template>
  <dashboard-card class="db-batches" title="Lotes por convênio" :note="note">
    <div class="loading loading-lg db-card-loading" v-if="loading"></div>

    <dashboard-empty
      v-else-if="rows.length === 0"
      icon="layer-group"
      title="Nenhum lote em aberto no período"
      reason="Nenhum lote enviado ou aguardando retorno da operadora. Feche um lote com as guias
              em aberto para acompanhar o recebimento aqui."
      action-to="/financial/billing-batches"
      action-label="Ir para Lotes"
      action-icon="layer-group"
    />

    <div class="db-card-table" v-else>
      <table class="table">
        <thead>
          <tr>
            <th>Convênio</th>
            <th class="text-right">Lotes</th>
            <th class="text-right">Valor</th>
            <th class="text-right">Prazo</th>
          </tr>
        </thead>
        <tbody>
          <tr class="db-row" v-for="row in rows" :key="row.key" @click="open(row)">
            <td class="db-name">
              {{ row.insuranceName }}
              <span class="db-sub" v-if="row.planName">{{ row.planName }}</span>
            </td>
            <td class="text-right db-num">
              {{ row.batches }}
              <span class="db-sub">{{ row.guidesLabel }}</span>
            </td>
            <td class="text-right db-num">
              {{ row.informed | currency }}
              <span class="db-sub db-error-text" v-if="row.glossed > 0">
                {{ row.glossed | currency }} glosado
              </span>
            </td>
            <td class="text-right">
              <span class="db-pill" :class="row.deadline.tone" :title="row.deadline.title"
                    v-if="row.deadline.label">{{ row.deadline.label }}</span>
              <span class="db-muted" v-else>—</span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>Total</td>
            <td class="text-right db-num">{{ totals.batches }}</td>
            <td class="text-right db-num">{{ totals.informed | currency }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </dashboard-card>
</template>

<script>
import {
  batchesRoute, daysSince, daysUntil, formatDate, pluralize,
} from '../helpers';
import DashboardCard from './DashboardCard.vue';
import DashboardEmpty from './DashboardEmpty.vue';

const WARNING_DAYS = 7;

export default {
  components: {
    DashboardCard,
    DashboardEmpty,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rows() {
      return this.items.map((item, index) => ({
        ...item,
        key: item.insuranceId || `row-${index}`,
        guidesLabel: pluralize(item.guides, 'guia', 'guias'),
        deadline: this.deadline(item),
      }));
    },
    totals() {
      return this.items.reduce((acc, item) => ({
        batches: acc.batches + item.batches,
        informed: acc.informed + item.informed,
      }), { batches: 0, informed: 0 });
    },
    note() {
      if (this.loading || this.items.length === 0) return '';
      return `${pluralize(this.totals.batches, 'lote', 'lotes')} aguardando retorno`;
    },
  },
  methods: {
    deadline(item) {
      const days = daysUntil(item.expectedPaymentAt);
      if (days === null) return { label: '', tone: '', title: '' };
      const parts = [`Previsão de recebimento em ${formatDate(item.expectedPaymentAt)}`];
      const sent = this.sentLabel(item.oldestSentAt);
      if (sent) parts.push(sent);
      const title = parts.join(' · ');
      if (days < 0) return { label: 'vencido', tone: 'db-pill-red', title };
      if (days === 0) return { label: 'hoje', tone: 'db-pill-red', title };
      const tone = days <= WARNING_DAYS ? 'db-pill-red' : 'db-pill-green';
      return { label: `${days}d`, tone, title };
    },
    sentLabel(value) {
      const days = daysSince(value);
      if (days === null) return '';
      if (days <= 0) return 'enviado hoje';
      return `enviado há ${pluralize(days, 'dia', 'dias')}`;
    },
    open(row) {
      this.$router.push(batchesRoute(row, this.filter));
    },
  },
};
</script>
